import { createSelector } from '@reduxjs/toolkit';

export interface SitePartnersData {
  allOrganisationsNames: string[];
}

export interface SitePartners {
  loaded: boolean;
  statusCode?: number;
  loading?: boolean;
  error?: boolean;
  data?: SitePartnersData;
}

export const selectSitePartners = createSelector(
  [(state) => state.sitePartners as SitePartners],
  (sitePartners) => sitePartners,
);
